module.exports = __webpack_public_path__ + "img/employment.38f4c773.png";